module.exports = __webpack_public_path__ + "static/party_bn2M@2x-8b031e357a35afcfb3008ed8e6c156e1.png";